import React from 'react';

export default function BeHappy(){
    return(
        <section>
            <h1>BeHappy</h1>
        </section>
    )
}